module.exports = __webpack_public_path__ + "img/star7.02b9d739.png";